"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var theme = require("./theme.scss");
var enums_1 = require("../../../../common/enums");
var ui_1 = require("@vidazoo/ui");
var ReportingConstraint = /** @class */ (function (_super) {
    tslib_1.__extends(ReportingConstraint, _super);
    function ReportingConstraint(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChange = function (e) {
            var _a = _this.props, onChange = _a.onChange, constraint = _a.constraint;
            var _b = e.target, name = _b.name, value = _b.value;
            onChange(constraint, name, value);
        };
        _this.onDelete = function () {
            var _a = _this.props, onDelete = _a.onDelete, constraint = _a.constraint;
            onDelete(constraint);
        };
        return _this;
    }
    ReportingConstraint.prototype.render = function () {
        var _a = this.props, index = _a.index, constraint = _a.constraint, fields = _a.fields;
        return (React.createElement("div", { className: theme.constraint },
            React.createElement("div", { className: theme.label },
                "Constraint ",
                index + 1),
            React.createElement("div", { className: theme.inputs },
                React.createElement(ui_1.AggregateChangeComponent, { onChange: this.onChange },
                    React.createElement(ui_1.FormSelect, { searchable: true, hideValidationMessage: true, required: true, placeholder: "Select Metric", name: "name", items: fields, maxItems: 5, itemValueKey: "value", itemLabelKey: "label", value: constraint.name, className: theme.input }),
                    React.createElement(ui_1.FormSelect, { hideValidationMessage: true, required: true, placeholder: "Select Operator", name: "op", maxItems: 6, items: enums_1.Operators, value: constraint.op, className: theme.input }),
                    React.createElement(ui_1.FormInput, { hideValidationMessage: true, required: true, placeholder: "Type a Value", type: "number", name: "value", fill: true, value: constraint.value, className: classnames(theme.input, theme.value, "flex-1") })),
                React.createElement("div", { className: theme.delete, onClick: this.onDelete },
                    React.createElement(ui_1.Icon, { iconName: "icon-delete", size: 1.8 })))));
    };
    ReportingConstraint.defaultProps = {};
    return ReportingConstraint;
}(React.Component));
exports.default = ReportingConstraint;
